import { EventPriceDto, UserToMembershipDto } from '../../models/dto';
import { getHighestDiscountMembership } from './get-lowest-ticket-price.utils';

/**
 * Get the membership that should be applied to ticket.
 * @param ticket
 * @param userMemberships
 */
export const getAppliedMembership = (ticket: EventPriceDto, userMemberships: UserToMembershipDto[]) => {
	const ticketMemberships = ticket.eventPriceToMemberships;

	const matchingMembership = ticketMemberships?.filter((ticketMembership) =>
		userMemberships.some((userMembership) => userMembership.membershipId === ticketMembership.membershipId)
	);

	if (!matchingMembership || matchingMembership.length === 0) {
		return;
	}

	return getHighestDiscountMembership(ticket.priceAmount, matchingMembership);
};
